import { saveCategoryPrompts } from '../../../actions/prompt/promptActions'
import { responseHandlerService } from '@/plugins/responseHandlerService'
import { updateSavedPrompts } from './update-saved-prompts'

/**
 * Saves all changed prompts
 * @param {string|number} assetId - The asset ID
 * @param {Array} categories - The category tree
 * @param {Set} changedCategories - Set of changed category IDs
 * @returns {Promise<Object>} - Result with success status
 */
export const saveChanges = async (assetId, categories, changedCategories) => {
  if (changedCategories.size === 0) {
    return Promise.resolve({ success: true, noChanges: true })
  }

  const changedItems = []

  // Find all changed categories in the tree
  const findChangedCategories = (categoryList) => {
    for (const category of categoryList) {
      if (changedCategories.has(category.id)) {
        changedItems.push({
          categoryId: category.id,
          imagePrompt: category.prompt?.tempImagePrompt || category.prompt?.image_prompt || '',
          videoPrompt: category.prompt?.tempVideoPrompt || category.prompt?.video_prompt || '',
        })
      }

      if (category.children?.length) {
        findChangedCategories(category.children)
      }
    }
  }

  findChangedCategories(categories)

  try {
    const response = await saveCategoryPrompts(assetId, changedItems)
    // Başarılı cevap
    // Update original values after successful save
    updateSavedPrompts(categories, changedItems)

    responseHandlerService.handleSuccess('Tüm değişiklikler başarıyla kaydedildi')
    return { success: true, savedCount: changedItems.length }
  } catch (error) {
    responseHandlerService.handleError('Değişiklikler kaydedilirken bir hata oluştu')
    return { success: false, error }
  }
}
